<!-- 模块标题通用组件 -->
<template>
	<!-- 标题 -->
	<div class="moduleTitle">
		<div class="text-center">
			<p>{{titleEngName}}</p>
			<em></em>
			<div class="d-flex" style="justify-content: center;position: relative;top:-10px;">
				<h2>{{titleName}}</h2>
				<h2 style="color: #FFA500;">{{titleLastName}}</h2>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
			titleName: {
				type: String,
				default: ''
			},
			titleEngName:{
				type: String,
				default: ''
			},
			titleLastName:{
				type: String,
				default: ''
			}
		},
	}
</script>

<style scoped>
	.moduleTitle{
		width: 1200px;
		margin: 0 auto;
		position: relative;
		top:10px
	}
	p{
		color: #999;
	}
	em{
		position: absolute;
		left: 50%;
		bottom:55px;
		display: block;
		width: 40px;
		height: 2px;
		background-color: #bf9961;
		margin-left: -20px;
	}
	h2{
		font-size: 26px;
		color: #333;
		text-align: center;
		font-weight: bold;
		letter-spacing: 3px;
		line-height: 1em;
		margin-top: 20px;
	}
</style>
